// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"229":"512a71ee","315":"1effa055"}[chunkId] + ".js";
};